import {
  FETCH_DASHBOARD_SUMMARY_REQUEST,
  FETCH_DASHBOARD_SUMMARY_SUCCESS,
  FETCH_DASHBOARD_SUMMARY_FAILURE,
} from "./dashboardActionTypes";

export const fetchDashboardSummaryRequest = () => ({
  type: FETCH_DASHBOARD_SUMMARY_REQUEST,
});

export const fetchDashboardSummarySuccess = (data, dataType) => ({
  type: FETCH_DASHBOARD_SUMMARY_SUCCESS,
  payload: { data, type: dataType },
});

export const fetchDashboardSummaryFailure = (error) => ({
  type: FETCH_DASHBOARD_SUMMARY_FAILURE,
  payload: error,
});